module.exports = __webpack_public_path__ + "static/media/popcorn-sleep.cd4ae164.png";